module.exports = __webpack_public_path__ + "static/media/icon-sourcing.4a6e39b6.svg";